import axiosFactory from "./axios.factory";

class OffersService {
  async getOffers(params) {
    const result = await axiosFactory().get("/offers", { params });
    return result.data;
  }

  async calculateOffer(payload) {
    const result = await axiosFactory().post("/offers/calculate", payload);
    return result.data.data;
  }

  async getCalculationStatus() {
    const result = await axiosFactory().get("/offers/calculations/status");
    return result.data.data;
  }

  async refreshCalculations() {
    const result = await axiosFactory().post("/offers/calculations/refresh");
    return result.data.data;
  }

  async getOfferCalculation(id) {
    const result = await axiosFactory().get(`/offers/${id}/calculation`);
    return result.data.data;
  }

  async getOffer(id) {
    const result = await axiosFactory().get(`/offers/${id}`);
    return result.data.data;
  }

  async createOffer(payload) {
    const result = await axiosFactory().post("/offers", payload);
    return result.data.data;
  }

  async updateOffer(id, payload) {
    const result = await axiosFactory().put(`/offers/${id}`, payload);
    return result.data.data;
  }

  async deleteOffer(id) {
    const result = await axiosFactory().delete(`/offers/${id}`);
    return result.data;
  }

  async getImageBlob(id) {
    const result = await axiosFactory().get(`/offers/${id}/image/content`, { responseType: "blob" });
    return result.data;
  }

  async uploadImage(id, file) {
    const formData = new FormData();
    formData.append("file", file);
    const result = await axiosFactory().post(`/offers/${id}/image`, formData, { headers: { "Content-Type": "multipart/form-data" } });
    return result.data.data;
  }

  async deleteImage(id) {
    const result = await axiosFactory().delete(`/offers/${id}/image`);
    return result.data;
  }

  /** KI-Handlungsempfehlung; dauert je nach Modell bis zu zwei Minuten. */
  async getAdvice(id) {
    const result = await axiosFactory().post(`/offers/${id}/advice`, null, { timeout: 200000 });
    return result.data.data;
  }
}

export default new OffersService();
